import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22a326c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "q-focus-helper",
  tabindex: "-1"
}, null, -1))
const _hoisted_2 = { class: "text-grey-5 text-no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    dense: "",
    class: "items-center q-hoverable"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_q_item_label, { class: "items-spacing" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.message.time.toLocaleString()), 1),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('channel-filter:update', _ctx.message.channel))),
            class: "text-clickable",
            role: "button"
          }, _toDisplayString('#' + _ctx.message.channel), 1),
          _createElementVNode("span", {
            style: _normalizeStyle({ color: _ctx.message.userColor }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('user-filter:update', _ctx.message.user))),
            class: "text-clickable",
            role: "button"
          }, _toDisplayString(_ctx.message.user), 5),
          _createElementVNode("span", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageParts, (part, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(part.type), _mergeProps({ key: index }, part.data), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(part.text), 1),
                  (part.tooltip)
                    ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(part.tooltip), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1040))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}